// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/anchor/style/index.less
// module id = 998
// module chunks = 1